import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { Employee } from "../../../state/types"
import { EmployeeList } from "./employeeList"
import { useEmployeeLoaders } from "../../../loaders/employeeLoaders"
import { TableName } from "../../../../../tables"
import { ListLoaderWrapper } from "../../../../../features/data-types"

export const Loader = () => {
    const [employees, setEmployees] = useState<Employee[]>([])
    const [ready, setReady] = useState(false)

    const employeeLoaders = useEmployeeLoaders()

    const populate = async () => {
        const { loadAllEmployees } = employeeLoaders()
        setEmployees(await loadAllEmployees(true))
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    return (
        <PanelLoader
            title="Empleados"
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.EMPLOYEES} />}
        >
            <EmployeeList employees={employees} />
        </PanelLoader>
    )
}

export const EmployeeListLoader = () => (
    <ListLoaderWrapper table={TableName.EMPLOYEES}>
        <Loader />
    </ListLoaderWrapper>
)
